import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { 
  Button, 
  TextField, 
  Grid, 
  MenuItem, 
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography,
  IconButton,
  Avatar,
  FormControl,
  InputLabel,
  Stepper,
  Step,
  StepLabel,
  Paper,
  Box
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Business as BusinessIcon,
  Person as PersonIcon,
  AccountBalance as BankIcon,
  LocationOn as LocationIcon,
  Save as SaveIcon
} from '@mui/icons-material';
import Swal from 'sweetalert2';
import { SwalConfig } from '../../utils/swalConfig';

const VendorAdd = () => {
  const [vendorData, setVendorData] = useState({
    vendor_name: '',
    pic_title: '',
    pic_last_name: '',
    pic_position: '',
    payment_address: '',
    address: '',
    id_city: '',
    id_province: '',
    id_country: '',
    phone: '',
    fax: '',
    mobile: '',
    email: '',
    business_type: '',
    term_of_payment: '',
    year_founded: '',
    id_bu: '',
    tax_no: '',
    bank_account_name: '',
    bank_account_number: '',
    bank_account_nameholder: '',
    bank_account_brench: '',
    is_active: 1,
    internal_pic: '',
  });
  const [loading, setLoading] = useState(false);
  const [buList, setBuList] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();

  const steps = [
    'Informasi Dasar',
    'Informasi PIC',
    'Informasi Bank',
    'Lokasi & Lainnya'
  ];

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const response = await axios.get('https://apidashboard.eurekagroup.id/bu');
        setBuList(response.data);
      } catch (error) {
        console.error('Error fetching business units:', error);
      }
    };
    fetchBusinessUnits();
  }, []);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleChange = (e) => {
    setVendorData({
      ...vendorData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const token = localStorage.getItem('token'); // Get token from localStorage
  
    try {
      await axios.post('https://apidashboard.eurekagroup.id/vendor/add', vendorData, {
        headers: {
          'Authorization': `Bearer ${token}`, // Add Authorization header with Bearer token
          'Content-Type': 'application/json', // Ensure Content-Type is set
        }
      });
  
      SwalConfig.success(
        'Berhasil!',
        'Data vendor berhasil ditambahkan! Vendor baru telah tersimpan dalam sistem.',
        2000
      );
      navigate('/kontak/vendor');
    } catch (error) {
      SwalConfig.error(
        'Gagal!',
        'Gagal menambahkan vendor! Silakan coba lagi atau hubungi administrator.'
      );
    } finally {
      setLoading(false);
    }
  };

  // Render form untuk step 1 - Informasi Dasar
  const renderBasicInfoForm = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Nama Vendor"
          name="vendor_name"
          value={vendorData.vendor_name}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Tipe Bisnis"
          name="business_type"
          value={vendorData.business_type}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Tahun Didirikan"
          name="year_founded"
          type="number"
          value={vendorData.year_founded}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Term of Payment"
          name="term_of_payment"
          type="number"
          value={vendorData.term_of_payment}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          select
          fullWidth
          label="Business Unit"
          name="id_bu"
          value={vendorData.id_bu}
          onChange={handleChange}
          variant="outlined"
        >
          {buList.map(bu => (
            <MenuItem key={bu._id} value={bu._id}>
              {bu.bu_name}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Tax No"
          name="tax_no"
          value={vendorData.tax_no}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );

  // Render form untuk step 2 - Informasi PIC
  const renderPICInfoForm = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="PIC Title"
          name="pic_title"
          value={vendorData.pic_title}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="PIC Last Name"
          name="pic_last_name"
          value={vendorData.pic_last_name}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="PIC Position"
          name="pic_position"
          value={vendorData.pic_position}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Internal PIC"
          name="internal_pic"
          value={vendorData.internal_pic}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Phone"
          name="phone"
          value={vendorData.phone}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Mobile"
          name="mobile"
          value={vendorData.mobile}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Fax"
          name="fax"
          value={vendorData.fax}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Email"
          name="email"
          value={vendorData.email}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );

  // Render form untuk step 3 - Informasi Bank
  const renderBankInfoForm = () => (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Bank Account Name"
          name="bank_account_name"
          value={vendorData.bank_account_name}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Bank Account Number"
          name="bank_account_number"
          value={vendorData.bank_account_number}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Bank Account Name Holder"
          name="bank_account_nameholder"
          value={vendorData.bank_account_nameholder}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          fullWidth
          label="Bank Account Branch"
          name="bank_account_brench"
          value={vendorData.bank_account_brench}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
    </Grid>
  );

  // Render form untuk step 4 - Lokasi & Lainnya
  const renderLocationForm = () => (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Address"
          name="address"
          value={vendorData.address}
          onChange={handleChange}
          variant="outlined"
          multiline
          rows={3}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          required
          fullWidth
          label="Payment Address"
          name="payment_address"
          value={vendorData.payment_address}
          onChange={handleChange}
          variant="outlined"
          multiline
          rows={3}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          required
          fullWidth
          label="City ID"
          name="id_city"
          value={vendorData.id_city}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          required
          fullWidth
          label="Province ID"
          name="id_province"
          value={vendorData.id_province}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          required
          fullWidth
          label="Country ID"
          name="id_country"
          value={vendorData.id_country}
          onChange={handleChange}
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          required
          select
          fullWidth
          label="Status"
          name="is_active"
          value={vendorData.is_active}
          onChange={handleChange}
          variant="outlined"
        >
          <MenuItem value={1}>Active</MenuItem>
          <MenuItem value={0}>Inactive</MenuItem>
        </TextField>
      </Grid>
    </Grid>
  );

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return renderBasicInfoForm();
      case 1:
        return renderPICInfoForm();
      case 2:
        return renderBankInfoForm();
      case 3:
        return renderLocationForm();
      default:
        return 'Unknown step';
    }
  };

  return (
    <div className="animate-fade-in">
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <IconButton 
          onClick={() => navigate('/kontak/vendor')}
          sx={{ 
            bgcolor: 'primary.main',
            color: 'white',
            '&:hover': { 
              bgcolor: 'primary.dark',
              transform: 'translateY(-2px)'
            },
            transition: 'all 0.3s ease',
            mr: 2
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }} className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
            ✨ Tambah Vendor Baru
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
            Lengkapi informasi vendor dengan mengikuti langkah-langkah berikut
          </Typography>
        </Box>
      </Box>

      {/* Stepper */}
      <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                StepIconProps={{
                  sx: {
                    '&.Mui-completed': {
                      color: 'success.main',
                    },
                    '&.Mui-active': {
                      color: 'primary.main',
                    },
                  },
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {label}
                </Typography>
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Paper>

      {/* Form Content */}
      <Card sx={{ boxShadow: '0 8px 32px rgba(0,0,0,0.1)', borderRadius: 3 }}>
        <CardHeader 
          title={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                {activeStep === 0 && <BusinessIcon />}
                {activeStep === 1 && <PersonIcon />}
                {activeStep === 2 && <BankIcon />}
                {activeStep === 3 && <LocationIcon />}
              </Avatar>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {steps[activeStep]}
              </Typography>
            </Box>
          }
        />
        <Divider />
        <CardContent sx={{ p: 4 }}>
          <form onSubmit={handleSubmit}>
            {renderStepContent(activeStep)}
          </form>
        </CardContent>
      </Card>

      {/* Navigation Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          variant="outlined"
          sx={{ 
            borderRadius: 2,
            px: 3,
            py: 1.5,
            textTransform: 'none',
            fontWeight: 600
          }}
        >
          ⬅️ Kembali
        </Button>
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          {activeStep === steps.length - 1 ? (
            <Button
              onClick={handleSubmit}
              variant="contained"
              disabled={loading}
              className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700"
              sx={{ 
                borderRadius: 2,
                px: 4,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                  transform: 'translateY(-2px)'
                }
              }}
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
            >
              {loading ? 'Menyimpan...' : '💾 Simpan Vendor'}
            </Button>
          ) : (
            <Button
              onClick={handleNext}
              variant="contained"
              color="primary"
              className="bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700"
              sx={{ 
                borderRadius: 2,
                px: 3,
                py: 1.5,
                textTransform: 'none',
                fontWeight: 600,
                '&:hover': {
                  transform: 'translateY(-2px)'
                }
              }}
            >
              Selanjutnya ➡️
            </Button>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default VendorAdd;
